const securityAmount = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/**
 * Per-security price and value always show cents. `formatCurrency` from
 * shared-utils rounds to whole dollars, which suits totals but turns a $12.49
 * price into "$12".
 */
export const formatSecurityAmount = (value: number): string => securityAmount.format(value);
